export class McqOptionModel {
    public mcqOptionId: number = -1;
    public option: string = '';
    public optionEn: string = '';
    public optionFr: string = '';
    public sequence: number = 0;
    public isOther: boolean = false;
}

export class MatrixRowColumnModel {
	public matrixId: number = -1;
	public text: string = '';
	public textEn: string = '';
	public textFr: string = '';
	public sequence: number = 0;
}
